import { useMutation } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Fragment } from 'react';

import { CreateOrganizationForm } from '@/components/management/form/CreateOrganizationForm';
import { FormGridLayout } from '@/components/management/form/formHelpers/FormGridLayout';
import { AdministrationBody } from '@/components/management/layout/AdministrationBody';
import { AdministrationHeader } from '@/components/management/layout/AdministrationHeader';
import { useScrollSpy } from '@/hooks/useScrollSpy';
import { backendApiOrganizationsCreateMutation } from '@/modules/api/backend/@tanstack/react-query.gen';
import { useSnackbarStore } from '@/stores/useSnackbarStore';

export const Route = createFileRoute('/_authenticated/management/organizations/create')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
  beforeLoad: async () => ({ breadcrumb: 'Neue Organisation' as const }),
});

function RouteComponent() {
  const navigate = Route.useNavigate();

  const { openSnackbar } = useSnackbarStore((state) => state.actions);

  const { mutateAsync } = useMutation({
    ...backendApiOrganizationsCreateMutation(),
    onSuccess: () => {
      navigate({ to: '/management/organizations', ignoreBlocker: true });
      openSnackbar({
        color: 'success',
        message: 'Die Organisation wurde erfolgreich erstellt!',
      });
    },
    onError: () => {
      openSnackbar({
        color: 'error',
        message: 'Fehler beim Erstellen der Organisation.',
      });
    },
  });

  const tabs = ['Organisation'];
  const { setRef, scrollTo, activeIndex } = useScrollSpy<HTMLDivElement>(tabs.length);

  return (
    <Fragment>
      <AdministrationHeader formId="organizationForm" label="Organisation erstellen" />
      <AdministrationBody>
        <FormGridLayout activeTab={activeIndex} onTabChange={scrollTo} tabs={tabs}>
          <CreateOrganizationForm
            setRef={setRef}
            tabs={tabs}
            onSubmit={async (values) => {
              await mutateAsync({ body: values });
            }}
          />
        </FormGridLayout>
      </AdministrationBody>
    </Fragment>
  );
}
